import { inject, Injectable } from '@angular/core';
import { SettingsCategory } from '../models/settings.model';
import { Validators } from '@angular/forms';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private authService = inject(AuthService);
  private http = inject(HttpClient);

  private readonly categories: SettingsCategory[] = [
    {
      id: 'profile',
      title: 'Profileinstellungen',
      icon: 'person',
      dataSourceKey: 'userProfile',
      items: [
        {
          id: 'username',
          type: 'username',
          key: 'username',
          title: 'Benutzername',
          icon: 'person',
          validators: [Validators.required, Validators.minLength(5)],
        },
        {
          id: 'change-email',
          type: 'email',
          key: 'email',
          title: 'E-Mail',
          icon: 'email',
          validators: [Validators.required, Validators.minLength(5)],
        },
        { id: 'profilePic', type: 'picture', key: 'profilePictureUrl', title: 'Profilbild', icon: 'picture' },

        // { id: 'bio', type: 'textarea', key: 'bio', title: 'Über mich', icon: '' },
      ],
    },
    {
      id: 'security',
      title: 'Sicherheit',
      icon: 'shield',
      dataSourceKey: 'userProfile',
      items: [{ id: 'change-password', type: 'password', key: 'password', title: 'Passwort ändern', icon: 'password' }],
    },
    {
      id: 'informations',
      title: 'Hilfe und Info',
      dataSourceKey: 'appConfig',
      icon: 'information-circle',
      items: [
        { id: 'blog', type: 'navigation-external', key: 'https://blog.rast-wc.de', title: 'Dev-Blog', icon: 'book' },
        { id: 'about', type: 'navigation', key: '/ueber-uns', title: 'Über Rast-WC', icon: 'help-circle' },
        { id: 'imprint', type: 'navigation', key: '/impressum', title: 'Impressum', icon: 'password' },
        { id: 'dsgvo', type: 'navigation', key: '/datenschutz', title: 'Datenschutzerklärung', icon: 'password' },
      ],
    },
  ];

  getCategories(): SettingsCategory[] {
    return this.categories;
  }

  getCategoryById(id: string): SettingsCategory | undefined {
    return this.categories.find((c) => c.id === id);
  }

  getDataFor(dataSourceKey: 'userProfile' | 'appConfig') {
    if (dataSourceKey === 'userProfile') {
      return this.authService.currentUserValue;
    }
    return {};
  }

  updateUsername(username: string): Observable<any> {
    return this.http.post(`${environment.backend}/settings/changeUsername`, username);
  }

  updateEmail(email: string): Observable<any> {
    return this.http.post(`${environment.backend}/settings/changeEmail`, email);
  }

  updatePassword(password: string): Observable<any> {
    return this.http.post(`${environment.backend}/settings/changePassword`, password);
  }

  checkUsernameAvailability(username: string): Observable<any> {
    return this.http.get(`${environment.backend}/settings/checkUsername`, {
      params: { username },
    });
  }

  checkEmailAvailability(email: string): Observable<any> {
    return this.http.get(`${environment.backend}/settings/checkEmail`, {
      params: { email },
    });
  }

  saveData(dataSourceKey: 'userProfile' | 'appConfig', formData: any) {
    console.log(`Speichere Daten für ${dataSourceKey}:`, formData);

    if (formData.username) {
    }
  }
}
